module.exports = __webpack_public_path__ + "img/Lacey.423fc171.jpeg";